import { RedoTextInput } from "@redotech/arbiter/input/redo-text-input";
import { groupInput, input, InputSchema } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { memo } from "react";

export const ETAExpressCarrierInput = groupInput({
  apiKey: input<string>({ validator: nonEmptyValidator }),
});

export type ETAExpressCarrierValue = InputSchema.Value<
  typeof ETAExpressCarrierInput
>;

export type ETAExpressCarrierForm = InputSchema.Input<
  typeof ETAExpressCarrierInput
>;

export const ETAExpressCarrierDefault = (): ETAExpressCarrierValue => ({
  apiKey: "",
});

export const CreateETAExpressCarrierForm = memo(
  function CreateETAExpressCarrierForm({
    carrierInput,
  }: {
    carrierInput: ETAExpressCarrierForm;
  }) {
    return (
      <RedoTextInput
        label="API key"
        placeholder=""
        setValue={carrierInput.inputs.apiKey.setValue}
        value={carrierInput.inputs.apiKey.value}
      />
    );
  },
);
